module.exports = __webpack_public_path__ + "static/media/my-resume-for-careers.e642004a.jpg";